<body data-spy="scroll" data-target=".fixed-top">
  <!-- <div > -->
      <!-- Navigation -->
    <!-- end of navbar -->
    <!-- end of navigation -->
  
  
 <!-- <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container"> -->

            <!-- Text Logo - Use this if you don't have a graphic logo -->
            <!-- <a class="navbar-brand logo-text page-scroll" href="index.html">Kora</a> -->

            <!-- Image Logo --> 
            <!-- <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>

           <button class="navbar-toggler p-0 border-0" type="button" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="true" aria-label="toggle navigation" data-toggle="collapse">
                <span class="navbar-toggler-icon"></span>
            </button> 

            <div class="collapse1" id="navbarsExampleDefault">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link page-scroll" routerLink="/" >Home <span class="sr-only">(current)</span></a>
                    </li>
                    
                    <li class="nav-item">
                        <a routerLink="/intro" class="nav-link page-scroll"   (click)="gotoScroll('intro')">Intro</a>
                    </li>
                     <li class="nav-item">
                        <a routerLink="/howItWorks" class="nav-link page-scroll"   (click)="gotoScroll('details')">How it Works</a>
                    </li> 
                    <li class="nav-item">
                        <a routerLink="/features" class="nav-link page-scroll"   (click)="gotoScroll('features')">Features</a>
                    </li>
                   
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/contact-us" class="nav-link page-scroll"  href="javascript:void(0)"  >Contact Us </a>
                    </li>
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/faqs" class="nav-link page-scroll"  href="javascript:void(0)"   >FAQ's</a>
                    </li> -->
                  <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Drop</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown01">
                            <a class="dropdown-item page-scroll" href="article.html">Article Details</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="terms.html">Terms Conditions</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="privacy.html">Privacy Policy</a>
                        </div>
                    </li>  -->
                     <!-- <li class="nav-item" *ngIf="this.extra" >
                            <a routerLink="/account/register-email" class="btn-solid-sm page-scroll" href="">Signup</a>
                            <a  routerLink="/account/login"  class="btn-solid-sm page-scroll" href="">Login</a>
                     </li>
                     <li class="nav-item" *ngIf="!this.extra"  >
                        <a  routerLink=""   class="btn-solid-sm page-scroll" (click)="dashboard()">Go to Content List</a>
                        <a routerLink="/account/login"   class="btn-solid-sm page-scroll" (click)="logout()">Logout</a>
                     </li>
                </ul> -->
               
                 <!-- <span class="nav-item" *ngIf="user">
                    <a routerLink="/{{ (user.type == 1) ? 'buyer' : 'seller'}}" class="btn-solid-sm page-scroll" href="">Dashboard</a>
                </span> -->
            <!-- </div> end of navbar-collapse -->
        <!-- </div> end of container -->
    <!-- </nav>   -->
  <!-- </div> -->
<app-public-navbar></app-public-navbar>

    <!-- <div class="container mt-3">
        <div class="row">
          <div class="col-12">
            <div class="page-title-box d-flex align-items-end justify-content-end ">
              <h4 class="mb-0 font-size-18">Sales Support</h4>
              <div class="page-title-right">
                <ol class="breadcrumb m-0">
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            
              <div class="card-2"> -->
                <!-- <div class="row">
              <div class="col-lg-6 ">
               <img  class="img-fluid" src="assets/images/sales-Support.png"> 
              </div>
              <div class="media-body col-lg-6">
                <h5 class="font-size-15">Quick Way to Connect With your Customers</h5>
                <p class="text-muted">New common language will be more simple and regular than the existing
                  European
                  languages. It will be as simple as occidental.</p>
              </div>
            </div> -->
                <!-- <div class="row m-3">
      
                  <div class=" col-lg-6">
                    <h2 class="font-size-35 buyer">Buyer</h2>
                    <p class=" text-muted ">As a Buyer we understand the painful ways
                      one has to go through for getting the desired content in this digital ecosystem
                    <p>
      
                    <p class="text-muted">
                      Connekkt Xchange has specialized team who can fetch your desired content based on your requirement and
                      handle all the end to end onboarding with ease
                    <p>
      
                    <p class="text-muted">
                      Just opt for the Expert sales support of Connekkt Xchange and we would reach you for the details and close
                      deals on your behalf</p>
                  </div>
                  <div class="col-lg-6">
                    <img class="img-fluid" src="assets/images/sales-Support-buyer.png">
                  </div>
                </div>
                <div class="row m-3">
                  <div class="col-lg-6">
                    <img class="img-fluid" src="assets/images/sales-Support-seller.png">
                  </div>
                  <div class="col-lg-6 mt-3">
                    <h2 class="font-size-35 seller">Seller</h2>
                    <p class="text-muted">As a seller we understand the painful ways a seller has to go through
                      for marketing the content and getting the right value of the content to reaching the appropriate
                      audience.</p>
                    <p class=" text-muted">Connekkt Xchange Sales Support solves this issue by identifying right
                      buyers and getting the right value for the deal.</p>
                    <p class=" text-muted">Just register yourself on Connekkt Xchange and opt for the Expert Sales
                      Support to market your content in a breeze.</p>
                      <div class="row">
                        <div class="col-12 d-flex justify-content-center">
                          <button class="btn btn-danger  modalContact" (click)="smallModal(largeDataModal)">Talk to an
                            Expert</button>
                        </div>
                      </div>
                  </div>
                </div>
              
              </div>
           
          </div>
        </div>
      </div>
 -->













      
    <!-- Footer -->
    <!-- <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-col first">
                        <h6>About Connekkt Xchange</h6>
                        <p class="p-small">Blockchain powered Video/Audio Content Rights Marketplace.
                            World’s only Assisted sales platform for Digital Media Content Rights
                        </p>
                    </div> end of footer-col -->
                    <!-- <div class="footer-col second">
                        <h6>Useful Links</h6>
                        <ul class="list-unstyled li-space-lg p-small">
                            <li><a href="/terms&conditions">Terms & Conditions</a><br/> <a href="/privacy-policy">Privacy
                                    Policy</a></li> -->
                            <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                    href="#">Illustrations</a></li>
                            <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                    href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                    class="page-scroll" href="#details">Details</a></li> -->
                        <!-- </ul> -->
                    <!-- </div> end of footer-col -->
                    <!-- <div class="footer-col third">
                        <span class="fa-stack">
                            <a href="#your-link">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-facebook-f fa-stack-1x"></i>
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-twitter fa-stack-1x"></i>
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-pinterest-p fa-stack-1x"></i>
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-instagram fa-stack-1x"></i>
                            </a>
                        </span>
                        <p class="p-small">We would love to hear from you <a
                                href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
                                <br/><a
                                    href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a></p>

                    </div> end of footer-col -->
                <!-- </div> end of col -->
            <!-- </div> end of row -->

             <!-- Copyright -->
    <!-- <div class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
                </div> end of col -->
            <!-- </div> enf of row -->
        <!-- </div> end of container -->
    <!-- </div> end of copyright -->
    
        <!-- </div> end of container -->
    <!-- </div> end of footer -->
    <!-- end of footer -->

   







<div class="container-fluids">

<div class="support-wrapper">
  <!-- <div class="overlay"></div> -->

  <div class="support-container">

    <!-- LEFT CONTENT -->
    <div class="support-content">
        <div class="support-content-heading">
        <p class="support-content-para">Don’t be afraid to say hello!</p>

      <h1>Drop us a note. </h1><h1> Lets Connekkt!</h1> 
</div>
      <p>
        Tell us what you need help with and one of our amazing <br/> team members will reach out soon.
      </p>

      <div class="support-contact">
        <div class="email-container">
            <img src="assets/newImages/mail.png" alt="">
        <div class="email">
          <span>Email</span><a href="mailto:support@connekktxchange.com">
          <strong>support@connectxchange.media</strong></a>
        </div>
        </div>
         <!-- <div class="phone-container">
            <img src="assets/newImages/phone.png" alt="">
        <div class="phone">
          <span>Phone</span>
          <strong>+44 07466 331893</strong>
        </div>
        </div> -->
      </div>
    </div>

    <!-- RIGHT FORM -->
    <div class="support-form">
      <h3>Looking for?</h3>

      <!-- SERVICES -->
     

      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
 <div class="radio-group">
    <div class="form-control-1">
        <label class="radio-item">
          <input  type="radio" value="buyer" formControlName="services" />
          <span>Buyer</span>
        </label>
      </div>
    <div class="form-control-1">

        <label class="radio-item">
          <input  type="radio" value="seller" formControlName="services" />
         <span>Seller</span> 
        </label>
    </div>
    <div class="form-control-1">

        <label class="radio-item">
          <input  type="radio" value="enquiry" formControlName="services" />
         <span>Enquiry</span> 
        </label>
    </div>
      </div>
        <!-- NAME -->
        <input  class="form-control" type="text" placeholder="Your Name" formControlName="name" />
        <div class="invalidError" *ngIf="submitted && form.name.errors">
          Name is required*
        </div>

        <!-- EMAIL -->
        <input class="form-control" type="email" placeholder="Email Address" formControlName="email" />
        <div class="invalidError" *ngIf="submitted && form.email.errors">
          Valid email is required*
        </div>

        <!-- COUNTRY -->
        <select formControlName="country" (change)="onSelectCountry($event.target.value)">
          <option value="" disabled>Select Country</option>
          <option *ngFor="let c of countryCodesList" [value]="c.name">
            {{ c.name }}
          </option>
        </select>
        <div class="invalidError" *ngIf="submitted && form.country.errors">
          Country is required*
        </div>

        <!-- PHONE -->
        <div class="phone-number" >
          <input type="text" placeholder="Code" class="form-control phone-code"
            formControlName="country_code" disabled />

          <input type="text" placeholder="Mobile Number" class="form-control"
            formControlName="number"
            (keypress)="isNumber($event)"maxlength="12" />
        </div>
        <div class="invalidError" *ngIf="submitted && form.number.errors">
          Mobile number required*
        </div>

        <!-- LANDLINE -->
        <!-- <div class="landline-number">
          <input type="text" placeholder="Area Code" class="form-control landline-code"
            formControlName="area_code"
            (keypress)="isNumber($event)" />

          <input type="text" placeholder="Landline Number" class="form-control"
            formControlName="landline"
            (keypress)="isNumber($event)" />
        </div> -->

        <!-- MESSAGE -->
        <textarea rows="4" placeholder="Write your message"
          formControlName="message"></textarea>
        <div class="invalidError" *ngIf="submitted && form.message.errors">
          Message is required*
        </div>

        <button type="submit" class="send-btn">
          Send
        </button>

      </form>
    </div>

  </div>
</div>
</div>









    <!-- Footer -->
  <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-col first">
                        <h6>About Connekkt Xchange</h6>
                        <p class="p-small">Connekkt Xchange is a next‑generation B2B content marketplace that enables publishers, studios, platforms, and distributors to seamlessly discover, license, distribute, and monetize content across global markets.
                        </p>
                    </div> 
                     <div class="footer-col second">
                        <h6>Useful Links</h6>
                        <ul class="list-unstyled li-space-lg p-small">
                            <!-- <li><a href="/terms&conditions">Terms & Conditions</a><br/> <a href="/privacy-policy">Privacy
                                    Policy</a></li>  -->
                                     <li><a href="/terms&conditions">Terms & Conditions</a><br/> <a routerLink="/privacy-policy">Privacy
                                    Policy</a> <br><a routerLink="/faqs">FAQs</a> <br><a routerLink="/privacySettings">Cookie Preferences</a> <br><a routerLink="/contact-us">Contact Us</a></li>
           
                           <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                    href="#">Illustrations</a></li>
                            <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                    href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                    class="page-scroll" href="#details">Details</a></li>  -->
                  </ul>
                     </div>
                <div class="footer-col third">
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/twitter.png" alt="">

                              
                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-facebook-f fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/facebook.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-twitter fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/instagram.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-pinterest-p fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/pinterest.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-instagram fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <p class="p-small">We would love to hear from you <a
                                href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
                                <!-- <br/><a
                                    href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a></p> -->

                    </div> 
              </div> 
         </div>

 <div class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
                </div>
         </div> 
      </div> 
 
    
      </div> 
    </div> 
  </div>
    <!-- end of footer -->








</body>


  <!-- <ng-template #largeDataModal let-modal>
    <div class="modal-header  no ">
  
      <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
      <h2 class="d-flex justify-content-center mt-0 buyer">Get in touch!</h2>
      <h5 class="d-flex justify-content-center mt-0">Contact us to elevate your Content Outreach</h5>
      <div class="card_2">
        <div class="card_2">
          <div class="col-12"> -->
            <!-- <ngb-alert type="success" *ngIf="responseMessage" [dismissible]="false">
                {{responseMessage | titlecase}}
            </ngb-alert> -->
            <!-- <ngb-alert type="danger" *ngIf="error" [dismissible]="false">
              {{error | titlecase}}
            </ngb-alert>
          </div>
  
          <form class="row" [formGroup]="contactForm" #formDir="ngForm" (ngSubmit)="onSubmit()">
            <div class="col-6">
              <div class="mb-3 row">
                <label for="example-text-input" class="col-lg-6 col-form-label"> User Name</label>
                <div class="col-md-12">
                  <input class="form-control" formControlName="name" type="text" value="Name" id="example-text-input"
                    required placeholder="User Name"  autocomplete="off">
                  <div class="invalidError" *ngIf="(contactForm.get('name').invalid && formDir.submitted)">Name is
                    required*</div>
                </div>
              </div>
              <div class="mb-3 row">
                <label for="example-text-input" class="col-lg-6 col-form-label">Email</label>
                <div class="col-md-12">
                  <input class="form-control" formControlName="email" type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" value="Email" id="example-text-input" required
                    placeholder="email"  autocomplete="off">
                  <div class="invalidError" *ngIf="(contactForm.get('email').invalid && formDir.submitted)">Email is
                    required*</div>
                </div>
              </div>
              <div class="mb-3 row">
               
                  <label class="col-lg-6 col-form-label"> Country</label>
                 <div class="col-md-12">
                  <select class="form-select" formControlName="country" (change)="onSelectCountry(contactForm.get('country').value)">
                    <option value="" selected disabled>Select Your Country</option>
                    <option *ngFor="let option of countryCodesList" [ngValue]="option.name">{{option.name | titlecase}}</option>
                </select>
                <div class="invalidError" *ngIf="(contactForm.get('country').invalid && formDir.submitted)">Country is required*</div>
                 </div>
             
              </div>
              <div class="mb-3 row">
                <label for="example-text-input" class="col-lg-6 col-form-label">Mobile no.</label>
           <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">
                  <input type="text" class="form-control" disabled formControlName="country_code">
              </div>
              <div class="col-md-9"> -->
                  <!-- <input type="text" formControlName="phone" pattern="[1-9]{1}[0-9]{9}" (keypress)="isNumber($event)" required class="form-control" placeholder="Enter Phone Number"> -->
                  <!-- <input type="text" formControlName="number" maxlength="10" pattern="[1-9]{1}[0-9]{9}" (keypress)="isNumber($event)" required class="form-control" placeholder="Enter Phone Number">
                  <div class="invalidError" *ngIf="(contactForm.get('number').invalid && formDir.submitted)">Mobile Number  is required*</div>
              </div>
          </div>
           </div>
                
              </div>
              <div class="mb-3 row">
                <label for="example-text-input" class="col-lg-6 col-form-label">Services</label>
                <div class="col-md-12">
                  <select class="form-select" formControlName="services" >
                    <option value="" selected disabled>Select your services</option>
                    <option value="buyer">Buyer
                    </option>
                    <option value="seller">Seller
                    </option>
                    <option value="enquiry">Enquiry
                    </option>
  
  
  
  
                  </select>
                  <div class="invalidError" *ngIf="(contactForm.get('services').invalid && formDir.submitted)">Service
                    is required*</div>
                </div>
              </div>
              <div class="row mb-3">
                <re-captcha formControlName="recaptchaReactive" (resolved)="addTokenLog('Reactive form mode resolved', $event)">
                </re-captcha>
                <div class="invalidError" *ngIf="(contactForm.get('recaptchaReactive').invalid && formDir.submitted)">Captcha
                  is required*</div>
    
              </div>
              
            </div>
            <div class="col-6">
              <div class="mb-3 row">
                <label for="example-text-input" class="col-lg-6 col-form-label">Message</label>
                <div class="col-md-12">
                  <textarea class="form-control" type="text" rows="10" formControlName="message"
                    id="example-text-input"></textarea>
                  <div class="invalidError" *ngIf="(contactForm.get('message').invalid && formDir.submitted)">Message
                    is required*</div>
                </div>
              </div>
            </div>
            
          
	
           
            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <button class="btn btn-danger contact" type="submit"  >Send Message</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      
    </div>
  </ng-template> -->